import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    currentUser: null,
    pulseAccountId: null,
    awsRegions: null,
    isSessionExpired: false,
    sessionExpiredReason: null
};
const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        setCurrentUser(state, action) {
            state.currentUser = action.payload;
        },
        setPulseAccountId(state, action) {
            state.pulseAccountId = action.payload;
        },
        setAWSRegions(state, action) {
            state.awsRegions = action.payload;
        },
        setIsSessionExpired(state, action) {
            state.isSessionExpired = action.payload;
        },
        setSessionExpiredReason(state, action) {
            state.sessionExpiredReason = action.payload;
        },
        resetAuthSlice(state) {
            state.currentUser = null;
            state.pulseAccountId = null;
            state.isSessionExpired = false;
            state.sessionExpiredReason = null;
        }
    }
});
export const { setCurrentUser, setPulseAccountId, setSessionExpiredReason, setAWSRegions, setIsSessionExpired, resetAuthSlice } = authSlice.actions;
export default authSlice.reducer;
